import React, { useEffect, useState } from "react";
import { useNavigate, useMatch, useSearchParams } from "react-router-dom";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import Dropdown, { OPTION_DISPLAY } from "@acadia-ui/dropdown";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import { ComparisonGrid } from "./ComparisonGrid";
import TaxonomyString from "../../Components/Tooltips/TaxonomyString/TaxonomyString";
import TabGroup from "@acadia-ui/tabs";
import AppSDK from "@growthos/ui-app-sdk";
import Loading from "@acadia-ui/loading";
import { ToastContainer } from "@acadia-ui/toast";

import { useColumnsAndData } from "./useColumnsAndData";

import "./index.scss";
import { fetchCampaigns, downloadCrossPlatformQAReport } from "../../Flux/Actions/MasterCampaignActions";
import { PLATFORM_MAP } from "./constants";

export default () => {
	const match = useMatch("/CrossPlatformQA/:campaignId");
	const [searchParams] = useSearchParams();

	const [campaigns, setCampaigns] = useState({});
	const [platforms, setPlatforms] = useState([]);

	const [selectedPlatform, setSelectedPlatform] = useState(
		// match?.params?.platformId
		// 	? {
		// 			value: match?.params?.platformId,
		// 			label:
		// 				Object.values(PLATFORM_MAP).find(({ id }) => id == match?.params?.platformId)?.label || 'Invalid Platform',
		// 	  }
		// 	: null
		[]
	);

	const [selectedCampaign, setSelectedCampaign] = useState(match?.params?.campaignId ? { label: searchParams.get("campaignName"), value: match?.params?.campaignId } : null);
	const [masterCampaignId, setMasterCampaignId] = useState(searchParams.get("masterCampaignId") || null);
	const [hierarchyLevelId, setHierarchyLevelId] = useState(searchParams.get("hierarchyLevelID") || null);

	const [showAllOSColumns, setShowAllOSColumns] = useState(true);
	const [refreshFlag, setRefreshFlag] = useState(false);
	const [selectedTab, setSelectedTab] = useState(0);
	const [loadingCampaigns, setLoadingCampaigns] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingData, setLoadingData] = useState(false);

	// handles page redirection
	const history = useNavigate();

	const togglePlatformAPIs = () => {
		const statuses = BookFiltersStore.getSyncStatuses();
		const platformsToCheck = [1, 5];
		const enabledPlatforms = statuses?.filter(({ SyncStatus, MasterPlatformID }) => {
			return platformsToCheck.includes(MasterPlatformID) && SyncStatus == true;
		});
		if (enabledPlatforms && platforms.length === 0) {
			const statuses = BookFiltersStore.getSyncStatuses();
			const platformsToCheck = [1, 5];
			const platformNames = {
				1: "Google Campaign Manager",
				5: "Mediaocean (OX)/Prisma"
			};
			const enabledPlatforms = statuses
				?.filter(({ SyncStatus, MasterPlatformID }) => {
					return platformsToCheck.includes(MasterPlatformID) && SyncStatus == true;
				})
				.map((platform) => {
					return { value: platform.MasterPlatformID, label: platformNames[platform.MasterPlatformID] };
				});

			// If there is only a single enabled platform, set it automatically
			if (enabledPlatforms.length === 1) {
				setSelectedPlatform([enabledPlatforms[0]]);
			}
			setPlatforms(enabledPlatforms);
		}
	};

	const parseCampaignData = (data) => {
		try {
			const accumulatedCampaigns = {};
			data?.forEach(({ ActivationCampaigns }) => {
				Object.entries(ActivationCampaigns).forEach(([key, val]) => {
					if (!Object.keys(accumulatedCampaigns).includes(key)) {
						accumulatedCampaigns[key] = val;
					} else {
						accumulatedCampaigns[key] = [...accumulatedCampaigns[key], ...val];
					}
				});
			});

			setCampaigns(accumulatedCampaigns);
			setLoadingCampaigns(false);

			// if (match?.params?.campaignName) {
			// const { campaignNameLookupKey } = Object.values(PLATFORM_MAP)?.find(({ id }) => id == selectedPlatform.value);
			// const { CampaignName_Friendly } = accumulatedCampaigns?.["Mediaocean (OX)/Prisma"]?.find(({ CampaignID }) => CampaignID == match.params.campaignId);
			// setSelectedCampaign({ ...selectedCampaign, label: match?.params?.campaignName });
			// }
		} catch (e) {
			setPlatforms([]);
			setCampaigns([]);
			setSelectedCampaign({ ...selectedCampaign, label: match.params.campaignId || null });
			setLoadingCampaigns(false);
		}
	};

	const handleDownloadCrossPlatformQAReport = () => {
		const campaignId = selectedCampaign?.value;
		setLoading(true);
		downloadCrossPlatformQAReport(
			campaignId,
			selectedPlatform.map((platform) => {
				return platform.value;
			})
		)
			.then((response) => {
				let formattedFileName = "CrossPlatformQA_Report.xlsx";
				const contentDisposition = response.request.getResponseHeader("Content-Disposition");
				if (contentDisposition && contentDisposition.indexOf("attachment") !== -1) {
					const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					const matches = filenameRegex.exec(contentDisposition);
					if (matches != null && matches[1]) {
						formattedFileName = matches[1].replace(/['"]/g, "");
					}
				}
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", formattedFileName);
				document.body.appendChild(link);
				link.click();
			})
			.finally(() => {
				setLoading(false);
			});
	};

	// get the campaign data from the data store.
	useEffect(() => {
		TaxonomyString.loadTaxonomyString("cross_platform_qa_taxonomy_string");
		BookFiltersStore.on("fetchSyncStatusesSuccess", togglePlatformAPIs);
		BookFiltersStore.on("fetchSyncStatusesFailure", togglePlatformAPIs);
		MasterCampaignsStore.on("campaignfetch", () => parseCampaignData(MasterCampaignsStore.getData()));
		togglePlatformAPIs();

		const data = MasterCampaignsStore.getData();
		if (data?.length > 0) {
			parseCampaignData(data);
		} else {
			// setLoadingCampaigns(true);
			// fetchCampaigns();
		}

		return () => {
			BookFiltersStore.removeListener("fetchSyncStatusesSuccess", togglePlatformAPIs);
			BookFiltersStore.removeListener("fetchSyncStatusesFailure", togglePlatformAPIs);
			MasterCampaignsStore.removeListener("campaignfetch", parseCampaignData);
		};
	}, []);

	const columnsAndData = useColumnsAndData({
		campaignId: selectedCampaign?.value,
		selectedPlatforms: selectedPlatform,
		tab: selectedTab,
		showAllOSColumns,
		refreshFlag,
		loadingData: setLoadingData
	});

	const TabContents = (props) => (
		<div className="cpqa-grid">
			<ComparisonGrid
				{...columnsAndData}
				type={props.type}
				history={history}
				campaignID={selectedCampaign?.value}
				hasValidDropdowns={selectedCampaign?.value || false}
				refreshFlag={refreshFlag}
				setRefreshFlag={setRefreshFlag}
				showAllOSColumns={showAllOSColumns}
				setShowAllOSColumns={setShowAllOSColumns}
				downloadReport={handleDownloadCrossPlatformQAReport}
				legendPlatforms={selectedPlatform}
				platformId={selectedPlatform?.length === 1 ? selectedPlatform[0]?.value : null}
				masterCampaignID={masterCampaignId}
				hierarchyLevelID={hierarchyLevelId}
			/>
		</div>
	);

	const navigate = useNavigate();

	return (
		<div className="cpqa-container">
			<ToastContainer id="crossPlatformQABanners" />
			<div className="cpqa-dropdowns">
				<Dropdown
					options={
						campaigns?.[selectedPlatform?.label]?.map(({ CampaignName_Friendly, CampaignID }) => ({
							label: CampaignName_Friendly,
							value: CampaignID
						})) || []
					}
					value={selectedCampaign}
					placeholder={loadingCampaigns ? "Loading Campaigns..." : "Select Campaign"}
					isSearchable={true}
					isClearable={true}
					disabled={true}
					onChange={(val) => setSelectedCampaign(val || null)}
				>
					Campaign Name
				</Dropdown>
				<Dropdown
					options={platforms || []}
					placeholder={loadingCampaigns ? "Loading Platforms..." : "Select Platform"}
					isSearchable={true}
					isClearable={true}
					multiple={true}
					display={OPTION_DISPLAY.PILL_INLINE}
					value={selectedPlatform ? selectedPlatform : null}
					disabled={loadingData}
					onChange={(val) => {
						setSelectedPlatform(val);
						// setSelectedCampaign(null);
					}}
				>
					Platform
				</Dropdown>
				{loadingCampaigns && <Loading />}
			</div>

			<TabGroup
				style={{ width: "100%" }}
				display={"button"}
				tabs={[
					{ label: "Campaign", panelId: "campaign-tab", disabled: false },
					{ label: "Package/Placement", panelId: "package-placement-tab", disabled: false }
				]}
				onSelect={(tabIndex) => {
					setSelectedTab(tabIndex);
					setShowAllOSColumns(true);
				}}
				selectedTab={selectedTab}
			>
				<div id="campaign-tab" role="tabpanel" aria-labelledby="Campaign">
					{selectedTab === 0 ? <TabContents type="Campaign" /> : <></>}
				</div>
				<div id="package-placement-tab" role="tabpanel" aria-labelledby="Package/Placement" hidden>
					{selectedTab === 1 ? <TabContents type="PackagePlacement" /> : <></>}
				</div>
			</TabGroup>

			{loading && <Loading fullscreen={true} />}
		</div>
	);
};
